<script>
	import Header from "./Header.svelte";

	import {
		isWideScreen,
		isMobile,
		noNeedSendButton,
		isNewDataChanged,
		currentEntityID,
		menuEntity,
	} from "../../../stores/variables";
	import {
		contentShellData,
		notificationData,
		entityData,
		clinicsData,
		currentActiveObjectData,
	} from "../../../stores/data";

	import { deleteNotify, addNotify } from "../../../scripts/notification";
	import { request } from "../../../scripts/request";
	import { changeHash } from "../../../scripts/change_hash";

	import { fade, fly } from "svelte/transition";

	import Organisations from "./content/Organisations.svelte";
	import Inputs from "../modules/simple/Inputs.svelte";
	import Image from "../modules/simple/Image.svelte";
	import Text from "../modules/simple/Text.svelte";
	import Domain from "../modules/complex/Domain.svelte";
	import DaDataAdress from "../modules/complex/DaDataAdress.svelte";
	import WorkModes from "../modules/complex/WorkModes.svelte";
	import Phones from "../modules/complex/Phones.svelte";
	import Information from "../modules/complex/Information.svelte";
	import Services from "../modules/complex/Services.svelte";
	import ClMainPhotos from "../modules/complex/ClMainPhotos.svelte";
	import AddImage from "../modules/complex/AddImage.svelte";
	import PriceList from "../modules/complex/PriceList.svelte";
	import Applications from "../modules/complex/Applications.svelte";
	import Reviews from "../modules/complex/Reviews.svelte";
	import Moderation from "../modules/complex/Moderation.svelte";
	import Select from "../modules/complex/Select.svelte";
	import Specialists from "../modules/specialists/Specialists.svelte";
	import Specialists_premods from "../modules/specialists/Specialists_premods.svelte";

	let componentList = [
		{
			ID: "Organisations",
			component: Organisations,
		},
		{
			ID: "Inputs",
			component: Inputs,
		},
		{
			ID: "Text",
			component: Text,
		},
		{
			ID: "Domain",
			component: Domain,
		},
		{
			ID: "DaDataAdress",
			component: DaDataAdress,
		},
		{
			ID: "WorkModes",
			component: WorkModes,
		},
		{
			ID: "Phones",
			component: Phones,
		},
		{
			ID: "Services",
			component: Services,
		},
		{
			ID: "ClMainPhotos",
			component: ClMainPhotos,
		},
		{
			ID: "AddImage",
			component: AddImage,
		},
		{
			ID: "PriceList",
			component: PriceList,
		},
		{
			ID: "Applications",
			component: Applications,
		},
		{
			ID: "Reviews",
			component: Reviews,
		},
		{
			ID: "Moderation",
			component: Moderation,
		},
		{
			ID: "Select",
			component: Select,
		},
		{
			ID: "Specialists",
			component: Specialists,
		},
		{
			ID: "Specialists_premods",
			component: Specialists_premods,
		},
		{
			ID: "Image",
			component: Image,
		},
		{
			ID: "Information",
			component: Information,
		},
	];

	let form;
	let buttonHandler;
	function checkValidation() {
		if (buttonHandler) return false;
		if (!$isNewDataChanged) return false;

		let is_valid = true;
		if (form) {
			Array.from(form.elements).forEach((element) => {
				if (!element.checkValidity()) {
					if (is_valid) {
						element.scrollIntoView({ behavior: "smooth" });
						element.classList.add("invalid");
						element.reportValidity();
					}
					is_valid = false;
				}
			});
		}
		if (!is_valid) return false;

		return true;
	}

	function handleSend() {
		if (!checkValidation()) return false;
		buttonHandler = 1;

		let sendData = {
			id: +$currentEntityID,
			data: {},
		};
		$contentShellData.blocks.forEach((block) => {
			block.field_names &&
				block.field_names.forEach((raw) => {
					if (
						!raw.not_for_post &&
						block.newData &&
						block.newData[raw]
					) {
						sendData.data[raw] = block.newData[raw];
					}
				});
		});

		if ($menuEntity == "clinic") {
			request
				.fetchData("updateclinic", "updateclinic", sendData, {}, form)
				.then((result) => {
					buttonHandler = 0;
					$isNewDataChanged = false;
					let isNewClinic = false;
					if (sendData.id == 0) {
						isNewClinic = true;
						if ($menuEntity == "clinic") {
							request
								.fetchData("clinicsList", "clinicsList")
								.then((res) => {
									$clinicsData = Object.values(
										res.data.clinics
									);
									$clinicsData.forEach((clinic) => {
										if (clinic.ID == result.id) {
											$currentActiveObjectData =
												$entityData = clinic;
											changeHash("clinic", result.id);
										}
									});
								});
						}
					}
					if (isNewClinic) {
						addNotify("Добавлена заявка на создание клиники");
					} else if (result.moder) {
						addNotify("Изменения сохранены");
					} else {
						addNotify("Добавлена заявка на изменение");
					}
					if (result.was_item_deleted || result.was_item_created) {
						// addNotify("Изменения произойдут после обновления");
						// location.reload();
					}
				});
		}

		if ($menuEntity == "doctor") {
			request
				.fetchData("updatedoctor", "updatedoctor", sendData, {}, form)
				.then((result) => {
					buttonHandler = 0;
					$isNewDataChanged = false;
					if (result.moder) {
						addNotify("Изменения сохранены");
					} else if (sendData.id == 0) {
						addNotify("Добавлена заявка на создание специалиста");
					} else {
						addNotify("Добавлена заявка на изменение");
					}
					if (
						result.data.was_item_created ||
						result.data.was_item_deleted
					) {
						addNotify(
							"Изменения произойдут после обновления странички"
						);
					}
				});
		}
	}
</script>

<div class="body">
	{#if $isWideScreen}
		<Header />
	{/if}

	<div
		class="body__content scrollbar-white {$isMobile
			? 'mobile'
			: 'not_mobile'}"
	>
		{#if $contentShellData}
			{#if $entityData}
				<form class="form" id="form" bind:this={form}>
					<div class="form__content">
						{#each $contentShellData.blocks as block}
							{#each componentList as component}
								{#if block.ID == component.ID}
									<div>
										<svelte:component
											this={component.component}
											data={block}
										/>
									</div>
								{/if}
							{/each}
						{/each}
					</div>
					{#if !$noNeedSendButton}
						<div
							class="form__button"
							class:active={$isNewDataChanged}
						>
							<button
								type="button"
								class="button"
								class:hidden={$noNeedSendButton}
								class:spin={buttonHandler}
								on:click|preventDefault={() => {
									handleSend();
								}}
							>
								{#if buttonHandler}
									<div
										class="button__loading"
										transition:fade
									>
										<div class="button__spinner" />
									</div>
								{/if}
								<span>Сохранить данные</span></button
							>

							<span
								>Нажмите сохранить данные чтобы изменения были
								внесены
							</span>
						</div>
					{/if}
				</form>
			{:else}
				<form class="form blank" class:active={$entityData}>
					<div class="form__blank" />
					<div class="form__content">
						{#each $contentShellData.blocks as block}
							{#each componentList as component}
								{#if block.ID == component.ID}
									<div>
										<svelte:component
											this={component.component}
											data={false}
										/>
									</div>
								{/if}
							{/each}
						{/each}
					</div>
					{#if !$noNeedSendButton}
						<div class="form__button">
							<button class=""
								><span>Сохранить данные</span></button
							>
						</div>
					{/if}
				</form>
			{/if}
		{/if}
		{#if $notificationData}
			<div class="notify">
				{#each $notificationData as notify}
					{#if !notify.hidden}
						<div
							class="notify__item"
							transition:fly
							on:click={() => {
								deleteNotify(notify);
							}}
						>
							{#if notify.type == "ok"}
								<i
									class="fas fa-check checkmark notify__checkmark"
								/>
							{/if}
							<span class="notify__text">{notify.text}</span>
							<i class="fas fa-times notify__cross" />
						</div>
					{/if}
				{/each}
			</div>
		{/if}
	</div>
</div>

<style lang="scss">
	.notify {
		display: flex;
		flex-direction: column;
		z-index: 100000;
		max-width: 280px;
		position: fixed;
		top: 80px;
		right: 24px;

		@media (max-width: 991px) {
			top: 24px;
		}

		&__checkmark {
			margin-right: 6px;
			font-size: 11px;
			background: #222;
			color: #fff;
			flex-shrink: 0;
			height: 22px;
			width: 22px;
			display: flex;
			align-items: center;
			justify-content: center;
			border-radius: 50%;
		}
		&__item {
			display: flex;
			justify-content: space-evenly;
			align-items: center;
			padding: 12px 24px;
			border-radius: 8px;
			background: var(--color-2);
			color: var(--text-black-1);
			width: 100%;
			cursor: pointer;
			margin-bottom: 12px;
			&:last-child {
				margin: 0;
			}
		}
		&__text {
			font-size: 13px;
			margin-right: 16px;
			font-weight: 600;
		}
		&__cross {
			font-size: 13px;
			font-weight: 600;
			margin-left: auto;
			display: flex;
			align-items: center;
			justify-content: center;
		}
	}
	.body {
		display: flex;
		flex-direction: column;
		flex-grow: 1;
		background: var(--bg-main-1);

		&__content {
			display: flex;
			flex-direction: column;
			flex-grow: 1;
			overflow: overlay;
			position: relative;
			padding: 40px 40px 30px;
			@media (max-width: 991px) {
				overflow: inherit !important;
			}
		}
	}
	.button {
		display: flex;
		position: relative;
		overflow: hidden;
		&__loading {
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			background-color: #000000b8;
			display: flex;
			align-items: center;
			justify-self: center;
		}
		&__spinner {
			position: absolute;
			height: 18px;
			width: 18px;
			border: 3px solid transparent;
			border-top-color: var(--color-1);
			left: calc(50% - 12px);
			border-radius: 50%;
			animation: spin 2s linear infinite;
			&:before,
			&:after {
				content: "";
				position: absolute;
				border: 3px solid transparent;
				border-radius: 50%;
			}
			&:before {
				border-top-color: var(--color-1);
				top: -12px;
				left: -12px;
				right: -12px;
				bottom: -12px;
				animation: spin 3s linear infinite;
			}
			&:after {
				border-top-color: var(--color-1);
				top: 6px;
				left: 6px;
				right: 6px;
				bottom: 6px;
				animation: spin 4s linear infinite;
			}
		}
	}
	.form {
		display: flex;
		flex-direction: column;
		position: relative;

		&.blank {
			z-index: -1;
			&.active {
				z-index: 0;
			}
		}

		&__button {
			position: relative;
			display: flex;
			flex-direction: column;
			order: 100000;
			flex-wrap: wrap;
			padding: 40px 0 0 0;
			z-index: 101;

			> span {
				display: none;
				font-size: 11px;
				color: var(--text-gray-1);
				@media (min-width: 992px) {
					align-items: center;
					justify-content: center;
					border-radius: 8px;
					font-size: 14px;
					padding: 0 20px;
					box-shadow: 1px 1px 6px 0px #13202a33;
					height: 44px;
					border: solid 1px #cfcfcf;
					background: #ffffff;
				}
			}

			> button {
				z-index: 999;
				align-self: flex-start;
				padding: 10px 40px;
				color: var(--text-black-1);
				outline: none;
				border: none;
				cursor: pointer;
				font-size: 16px;
				line-height: 24px;
				position: relative;
				@media (min-width: 992px) {
					max-width: var(--module-width-1);
					margin: 0 10px 10px 0;
				}
				width: 100%;
				display: flex;
				justify-content: center;
				align-items: center;
				border-radius: 8px;
				transition: all 0.2s ease;

				&.hidden {
					display: none;
				}

				> span {
					z-index: 1;
					position: relative;
				}

				&::before {
					content: "";
					display: none;
					position: absolute;
					height: 100%;
					width: 100%;
					background: black;
					border-radius: 6px;
					opacity: 0.1;
					top: 0;
					left: 0;
					z-index: 0;
				}

				&:hover {
					&::before {
						display: flex;
					}
				}
			}

			&.active {
				> button {
					color: var(--text-main-1);
					background-color: var(--color-3);
					box-shadow: 5px 5px 8px 0px #13202a33;
				}
				position: sticky;
				bottom: 0;

				@media (max-width: 991px) {
					bottom: 20px;
				}
			}
		}

		&__content {
			display: flex;
			flex-direction: column;
			> div {
				margin-bottom: 30px;

				&:last-child {
					margin: 0;
				}
			}
		}
		&__blank {
			position: absolute;
			top: 0;
			right: 0;
			left: 0;
			bottom: 0;
			z-index: 100;
			background: rgba(255, 255, 255, 0.575);
		}
	}
</style>
